(function () {
  const COUPONS = [
    { code: "", text: "Get 5% off on PrePaid Orders (on RazorPay Checkout Page)" }
    ];

  function createCouponCarousel() {
//     const discountContent = document.querySelector(".cart-drawer__header");
// if (!discountContent) return;

// const statusBar = document.createElement("div");
// statusBar.className = "lp-cart-status-bar";
// statusBar.innerHTML = `
//   <span>Free Shipping ✅</span>
//   <span>Discounts Applied ✅</span>
// `;

// discountContent.insertAdjacentElement("beforebegin", statusBar);

if (document.querySelector(".lp-coupon-carousel")) return true;

    const inputEl = document.querySelector(
      ".AOV-CDMinimal__FooterAction__Form__Input"
    );

  //  const inputEl = document.querySelector(".cart-drawer__summary");
//  const inputEl = document.querySelector(".cart-discount__content");
    if (!inputEl) return false;

    const wrapper = document.createElement("div");
    wrapper.className = "lp-coupon-carousel";

    wrapper.innerHTML = `
      <div class="lp-coupon-track">
        ${COUPONS.map(c => `
          <div class="lp-coupon-card">
            <div class="lp-coupon-info">
              ${c.code ? `<strong>${c.code}</strong>` : `<strong>Auto Applied</strong>`}
              <span>${c.text}</span>
            </div>
            ${c.code ? `
              <button class="lp-copy-btn" data-code="${c.code}">
                Copy
              </button>
            ` : `
              <button class="lp-copy-btn disabled" disabled>
                Applied
              </button>
            `}
          </div>
        `).join("")}
      </div>
    `;

    inputEl.insertAdjacentElement("afterend", wrapper);

    wrapper.addEventListener("click", function (e) {
      const btn = e.target.closest(".lp-copy-btn");
      if (!btn || btn.disabled) return;

      const code = btn.dataset.code;

      navigator.clipboard.writeText(code).then(() => {
        btn.classList.add("copied");
        btn.textContent = "Copied!";

        setTimeout(() => {
          btn.classList.remove("copied");
          btn.textContent = "Copy";
        }, 1500);
      });
    });

    return true;
  }

  const observer = new MutationObserver(() => {
    if (createCouponCarousel()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();



(function () {
  const delayList = [
    'cdn-sf.vitals.app',
    'kaktusapp.com',
    'cdnwidget.judge.me',
  ];

  const originalCreate = document.createElement;
  document.createElement = function(tag) {
    const el = originalCreate.call(document, tag);
    if (tag === 'script') {
      Object.defineProperty(el, 'src', {
        set(value) {
          if (delayList.some(d => value.includes(d))) {
            el.setAttribute('data-delayed-src', value);
          } else {
            el.setAttribute('src', value);
          }
        }
      });
    }
    return el;
  };

  window.loadDelayed = function () {
    document.querySelectorAll('script[data-delayed-src]').forEach(s => {
      s.src = s.dataset.delayedSrc;
      s.removeAttribute('data-delayed-src');
    });
  };
})();





document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
  form.addEventListener('submit', function(e) {
    e.preventDefault(); // STOP redirect
    const formData = new FormData(this);

    // Optional: send to Shopify via AJAX
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      console.log('Item added:', data);
      // Open your cart drawer here
      if (window.cartDrawer) {
        window.cartDrawer.open(); // Replace with your drawer function
      }
    })
    .catch(err => console.error(err));
  });
});



document.querySelectorAll('[data-add-to-cart], form[action="/cart/add"]').forEach(btn => {
  btn.addEventListener('click', function(e) {
    e.preventDefault();
    const form = this.closest('form');
    const formData = new FormData(form);

    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(res => res.json())
      .then(() => {
        console.log('YOLO')
        if (window.cartDrawer) window.cartDrawer.open();
      });
  });
});
